import React, { useMemo } from "react";
import { Divider, Progress } from "semantic-ui-react";
import { formatNumber } from "../../../utils/formatNumber";
import { useTranslation } from "react-i18next";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { AiFillDollarCircle } from "react-icons/ai";
import PromotionCard from "../../Vip/components/promotionCard";
import { IoCheckmarkCircle } from "react-icons/io5";

const FromWithdrawHint = ({ washConfig }) => {
  const { washPoint, betAmount } = washConfig;
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const notDepositYet = useMemo(() => {
    if (betAmount == 0 && washPoint == 0) return true;
    return false;
  }, [washConfig]);

  return (
    <>
      <section
        className={`rounded-[5px] flex flex-col gap-[5px] items-center justify-center p-[15px] bg-gradient-to-br bg-base-light-white dark:bg-base-light-dark`}
      >
        <div className="w-full flex items-center justify-between">
          <div className="flex items-center gap-[10px]">
            <div className="w-[35px] h-[35px] relative">
              <CircularProgressbar
                className="!w-[35px]"
                styles={buildStyles({
                  trailColor: "rgb(196 196 196) !important",
                  pathColor: `rgba(100,72,255,1)`,
                })}
                strokeWidth={6}
                value={notDepositYet ? 0 : (betAmount / washPoint) * 100}
              />
              <AiFillDollarCircle className="absolute absolute-center text-2xl text-[#D99E0A]" />
            </div>
            <span className="text-lg text-transaction-card-text dark:text-base-light-white font-medium">
              {i18n("withdrawNeedCondition")}
            </span>
          </div>
          <span className="text-transaction-card-text dark:text-base-light-white tracking-tighter font-medium text-lg">
            {formatNumber(betAmount, { point: false })} /{" "}
            {formatNumber(washPoint, { point: false })}
            <span className="text-sm text-light-text ml-[5px]">
              {i18n("bet")}/{i18n("washPoint")}.
            </span>
          </span>
        </div>
        <PromotionCard
          icon={
            <IoCheckmarkCircle
              className={`${
                notDepositYet
                  ? "text-gray-400"
                  : betAmount >= washPoint
                  ? "text-green-500"
                  : "text-gray-400"
              }`}
            />
          }
          label={`${i18n("arriveWagerNeedBet")}`}
          className={`w-full mt-[5px] ${
            betAmount >= washPoint && !notDepositYet ? "!bg-green-300" : ""
          }`}
          promotionProps={{
            description: notDepositYet
              ? `(${i18n("notDepositYet")})`
              : betAmount >= washPoint
              ? i18n("achieved")
              : formatNumber(betAmount - washPoint, { point: false }),
          }}
        />
        {/* <Progress
          className="customUi customUiHeight !mb-[0px] w-full"
          value={betAmount}
          total={washPoint}
          size="tiny"
          success
        />
        <div className="w-full flex items-center justify-between">
          <span className="text-[#ABD010] font-medium">
            {formatNumber((betAmount / washPoint) * 100)}%
          </span>
          <span className="text-xs text-light-text">
            {" "}
            {formatNumber(betAmount, { point: false })} /{" "}
            {formatNumber(washPoint, { point: false })} {i18n("until")}{" "}
          </span>
        </div> */}
      </section>
      <Divider />
    </>
  );
};

export default FromWithdrawHint;
